module.exports = __webpack_public_path__ + "img/blank_profile.6dcb5c45.svg";